export const defaultLoadingConfig = {
    isLoading: false,
    tip: "",
};
